export const backArrow = ["60, 60", `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.711 18.711">
        <defs>
            <style>.a{fill:#3c3c3b;}</style>
        </defs>
        <path className="a" 
            d="M9.918,19.274a9.356,9.356,0,1,1,9.356-9.356A9.354,9.354,0,0,1,9.918,19.274ZM14.294,8.258H9.918V5.584a.453.453,0,0,0-.773-.321L4.833,9.6a.449.449,0,0,0,0,.638L9.145,14.57a.453.453,0,0,0,.773-.321V11.578h4.376a.454.454,0,0,0,.453-.453V8.711A.454.454,0,0,0,14.294,8.258Z" 
            transform="translate(-0.563 -0.563)"/>
    </svg>
`]